
define('text!views/site/failure.html',[],function () { return '<div atn-role="login-box">\n    <div atn-role="form-box">\n        <h1 data-bind="text: capsProductName"></h1>\n        <div atn-role="logout-message" atn-role="report-error-message" data-bind="foreach:errorMessages">\n            <div atn-role="error-msg-div" data-bind="html:$data"></div>\n        </div>\n    </div>\n</div>\n';});

